import {Accident} from '@/read-model/accident';
import {accidents as spreadsheetAccidentsLoader, AccidentsGroupsLoader, groupAccidents} from '@/adapters/accidentsMap';
import {Action, getModule, Module, Mutation, VuexModule} from 'vuex-module-decorators';
import store from '@/store'
import {AccidentsGroup} from "@/read-model/AccidentsGroup";

let defaultLoader: AccidentsGroupsLoader = async () => groupAccidents(await spreadsheetAccidentsLoader())

export function replace(loader: AccidentsGroupsLoader) {
  defaultLoader = loader
}

export interface AccidentsState {
  accidents: Array<Accident>;
  activeAccident: Accident | null;
  groups: Array<AccidentsGroup>;
  activeGroup: AccidentsGroup | null;
}

@Module({
  dynamic: true,
  name: 'accidents',
  store,
})
export class Accidents extends VuexModule implements AccidentsState {
  public groups: Array<AccidentsGroup> = []
  public activeGroup: AccidentsGroup | null = null

  get accidents(): Array<Accident> {
    return this.groups.flatMap((group: AccidentsGroup) => group.accidents)
  }

  get activeAccident(): Accident | null {
    return this.activeGroup?.accidents[0] ?? null
  }

  @Action
  async load() {
    this.setGroups(await defaultLoader())
  }

  @Mutation
  setGroups(groups: Array<AccidentsGroup>) {
    this.groups = groups
  }

  @Action
  openAccident(accident: Accident) {
    this.setActiveAccident(accident)
  }

  @Mutation
  setActiveAccident(accident: Accident) {
    this.activeGroup = new AccidentsGroup([accident])
  }

  @Action
  closeAccident() {
    this.unsetActiveAccident()
  }

  @Mutation
  unsetActiveAccident() {
    this.activeGroup = null
  }

  @Action
  openGroup(group: AccidentsGroup): void {
    this.setActiveGroup(group)
  }

  @Mutation
  setActiveGroup(group: AccidentsGroup): void {
    this.activeGroup = group
  }

  @Action
  closeGroup(): void {
    this.unsetActiveAccident()
  }

  @Mutation
  unsetActiveGroup(): void {
    this.activeGroup = null
  }

  get miracles(): Array<AccidentsGroup> {
    return this.groups.map(group => group.miraclesOnly()).filter(group => group.accidents.length > 0)
  }
}

export const AccidentsModule = getModule(Accidents)
